module.exports = __webpack_public_path__ + "img/template.7ac4bd74.svg";